import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Órdenes y Embarques" },
  { label: "Ordenes de Compra",     icon: "fas fa-shopping-basket",  color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoOrdenesCompra", desc: "Emisión y seguimiento",     perm: "menu_oc" },
  { label: "OC Nacional",           icon: "fas fa-truck-loading",    color: "#059669", bg: "#ecfdf5", href: "/OrdenesCompraNacionalCreate", desc: "OC a proveedor nacional", perm: "menu_oc" },
  { label: "Recepciones",           icon: "fas fa-dolly",            color: "#2563eb", bg: "#eff6ff", href: "/Recepciones",          desc: "Recibir embarques y OC nacional", perm: "menu_compras" },
  { label: "Embarques",             icon: "fas fa-ship",             color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoEmbarques",     desc: "Contenedores y logística",  perm: "embarques" },
  { label: "Entradas",              icon: "fas fa-cart-plus",        color: "#3b82f6", bg: "#eff6ff", href: "/ListadoCompras",       desc: "Recepción de mercancía",    perm: "menu_compras" },
  { label: "Compras Directas",      icon: "fas fa-cart-arrow-down",  color: "#10b981", bg: "#ecfdf5", href: "/ComprasDirectasCreate", desc: "Compra sin OC ni embarque", perm: "menu_compras" },
  // { label: "OC Nacional",           icon: "fa-solid fa-cart-arrow-down", color: "#a855f7", bg: "#faf5ff", href: "/EmbarquesDirectosCreate", desc: "Compra directa nacional", perm: "menu_compras" },

  { type: "section", label: "Catálogos" },
  { label: "Proveedores",           icon: "fas fa-dolly",     color: "#f97316", bg: "#fff7ed", href: "/Proveedores",              desc: "Directorio de proveedores",     perm: "menu_proveedores" },
  { label: "Conceptos Gastos Embarque", icon: "fas fa-bars",  color: "#64748b", bg: "#f1f5f9", href: "/ConceptosGastosEmbarques", desc: "Conceptos aplicables a embarques", perm: "menu_compras" },

  { type: "section", label: "Análisis" },
  { label: "Pendiente Embarcar",    icon: "fas fa-plane-departure",  color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPendEmbarcar",  desc: "OC por embarcar",           perm: "pendiente_embarcar" },
  { label: "Pendiente Recibir",     icon: "fas fa-plane-arrival",    color: "#10b981", bg: "#f0fdf4", href: "/ListadoPendRecibir",   desc: "Embarques por llegar",      perm: "pendiente_recibir" },
  { label: "Reabasto",              icon: "fas fa-warehouse", color: "#14b8a6", bg: "#f0fdfa", href: "/ListadoReabasto",         desc: "Necesidades de reabasto",       perm: "menu_compras" },
  { label: "Sugerido de Reabasto",  icon: "fas fa-sync",      color: "#0891b2", bg: "#ecfeff", href: "/ListadoRotacion",         desc: "Sugerido por rotación",         perm: "menu_compras" },
  { label: "Tracking Compras",      icon: "fas fa-search",    color: "#6366f1", bg: "#eef2ff", href: "/ListadoTrackingCompras",  desc: "Seguimiento de compras",        perm: "seguimiento_inventarios" },
];

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-shopping-cart" color="#8b5cf6" bg="#f5f3ff" title="Compras" subtitle="Órdenes, embarques y proveedores" />
        {user.menu_compras ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              if (r.type === "section") return <MenuSection key={i} title={r.label} />;
              const enabled = r.permOr ? r.permOr.some((p) => !!user[p]) : !!user[r.perm];
              return <MenuCard key={i} {...r} enabled={enabled} />;
            })}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCompras;
